import styled from "@emotion/styled";
import { systemWidth } from "@kaltura/mediaspace-shared-styled";

export const StyledContentContainer = styled("div")(({ theme }) => ({
    ...systemWidth({ theme }),
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(3),
    gap: theme.spacing(3),
    marginBottom: theme.spacing(7.5),
}));

export const TitlePlaylistContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
}));

export const ContentContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
}));
